// extracted by mini-css-extract-plugin
module.exports = {"error":"NotFound_error__hKOE7","e500":"NotFound_e500__3e8h1","also":"NotFound_also__1-wY9","arrow":"NotFound_arrow__1DfOM"};